import defaultTheme from "./default";

import { createTheme } from "@mui/material";

const defaultFontFamily = {
	styleOverrides: {
		root: {
			fontFamily: "Quicksand-SemiBold",
		},
	},
};

const components = {
	MuiTypography: {
		...defaultFontFamily,
	},
	MuiButton: {
		styleOverrides: {
			root: {
				textTransform: "none",
				fontFamily: "Quicksand-SemiBold",
			},
		},
	},
	MuiOutlinedInput: {
		...defaultFontFamily,
	},
	MuiInputBase: {
		...defaultFontFamily,
	},
	MuiDataGrid: {
		styleOverrides: {
			root: {
				fontFamily: "Quicksand-SemiBold",
			},
			columnHeader: {
				"&:focus": {
					outline: "none",
				},
				"&:focus-within": {
					outline: "none",
				},
			},
		},
	},
	MuiChip: {
		...defaultFontFamily,
	},
	MuiTableCell: {
		...defaultFontFamily,
	},

	MuiFormLabel: {
		...defaultFontFamily,
	},
	MuiMenuItem: {
		...defaultFontFamily,
	},
	MuiDatePicker: {
		defaultProps: {
			views: ["year", "month", "day"],
		},
	},
};

const index = {
	default: createTheme({ ...defaultTheme, components }),
};

export default index;
